module.exports = __webpack_public_path__ + "img/arrow-left.658a5304.svg";